import { ReactElement, forwardRef } from "react";

import { ThemeColorKey, ThemeTypographyKey } from "chameleon/lib/theme/theme";

import { Text } from "../text/text";
import {
  labelWrapperClass,
  leadingSlotClass,
  trailingSlotClass,
  wrapperClass,
} from "./payment-method-title.css";

export interface PaymentMethodTitleProps {
  /**
   * Optional introductory icon added before title
   */
  leadingSlot?: JSX.Element;
  /**
   * Optional icon to append to end of radio button
   */
  trailingSlot?: JSX.Element;
  /**
   * For ID used for accessibility
   */
  forId?: string;
  /**
   * Title to display
   */
  title?: string;
  /**
   * aria label for screen readers
   */
  ariaLabel?: string;
  /**
   * Title component
   */
  titleComponent?: ReactElement;
  /**
   * Tab index for the input
   */
  titleStyleVariant?: ThemeTypographyKey;
  /**
   * tag eleement
   */
  tagElement?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "label" | "p" | "span";
  /**
   * Theme Color token to display
   */
  colorVariant?: ThemeColorKey;
}

export const PaymentMethodTitle = forwardRef<
  HTMLInputElement,
  PaymentMethodTitleProps
>(
  (
    {
      leadingSlot,
      trailingSlot,
      forId,
      title,
      ariaLabel,
      titleComponent,
      titleStyleVariant,
      tagElement = "h3",
      colorVariant,
    }: PaymentMethodTitleProps,
    ref
  ) => {
    return (
      <>
        {titleComponent ? (
          titleComponent
        ) : (
          <div className={`${wrapperClass}`} ref={ref}>
            {leadingSlot ? (
              <div className={`${leadingSlotClass}`}>{leadingSlot}</div>
            ) : null}
            <div className={`${labelWrapperClass}`}>
              <Text
                styleVariant={titleStyleVariant ?? "heading3"}
                tagElement={tagElement}
                htmlFor={forId}
                aria-label={ariaLabel}
                colorVariant={colorVariant}
              >
                {title}
              </Text>
            </div>
            {trailingSlot ? (
              <div className={`${trailingSlotClass}`}>{trailingSlot}</div>
            ) : null}
          </div>
        )}
      </>
    );
  }
);

PaymentMethodTitle.displayName = "PaymentMethodTitle";
